/**
 * http配置
 */

import axios from 'axios'
import router from './../router'
import { Message } from 'element-ui'
import cookie from './../util/cookie'
import util from './../util/util'
// 调用element 

// axios 配置
axios.defaults.timeout = 5000;
window.location.host.indexOf('xiaoiron') == -1 ? axios.defaults.baseURL = 'http://open.wegui.cn/v1' : axios.defaults.baseURL = 'https://open.xiaoiron.com/v1'
axios.defaults.headers.common['Xi-App-Id'] = util.appid;
// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = cookie.getCookie('xToken');
    if (token) {
      config.headers['Xi-Session-Token'] = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // Message({
    //   message: '操作成功！',
    //   type: 'success',
    //   duration: 2 * 1000
    // })
    return response;
  },
  error => {
    if (error.response && (error.response.status == 403)) {
      localStorage.removeItem('openUser');
      cookie.removeCookie('xToken') ;
      Message({
        message: 'token过期，请重新登录',
        type: 'error',
        duration: 2 * 1000
      })
      router.replace({
        path: '/login',
      })
    } else {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 2 * 1000
      })
    }
    return Promise.reject(error)
  });
router.beforeEach((to, form ,next)=>{
  let token = cookie.getCookie('xToken') ;
  if(to.path=='/login'){
    next();
  }
  if(!token){
    next('/login');
    localStorage.removeItem('openUser');
  }
  next();
})
export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js